// extracted by mini-css-extract-plugin
export default {"wrapper":"g5ZqY2C5Hl_product-carousel","block":"MOmvD1YX9y_product-carousel"};